import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { PersonService } from 'src/app/Service/Person/Person.service';

@Component({
  selector: 'app-PersonOption',
  templateUrl: './PersonOption.component.html',
  styleUrls: ['./PersonOption.component.scss']
})
export class PersonOptionComponent implements OnInit {


  @Output() OnBack_Person_Action = new EventEmitter<Array<Persone_List_Interface>>();
  Filter_title: String = ""
  constructor(
    private Person_Service: PersonService,
  ) { }

  ngOnInit() {
    this.Read_Person()
  }

  DataList_Person:Array<Persone_List_Interface>=[]
  Read_Person(){
    this.Person_Service.GetActive().subscribe(
      data=>{
        this.DataList_Person=data

      }
    )
  }

  Change_Item_Status(item: Persone_List_Interface)
  {
    item.del = !item.del
    this.set_Selected_Item()
  }

  set_Selected_Item() {
    var DataList_PersonTemp: Array<Persone_List_Interface> = []
    for (let item of this.DataList_Person)
    {
      if (item.del)
      {
        DataList_PersonTemp.push(item)
      }
    }

    this.OnBack_Person_Action.emit(DataList_PersonTemp);
  }
}
